import { hasQcCapability } from "./limsCapabilities"

// SPEC-025: dev-only — true when the BE has relaxed the LIMS GMP four-eyes + capability gates
// (mirrors the backend flag, which can only be set in local development). When true, canSign and
// the per-record ghost checks (reopen / lift) stop enforcing capability + segregation so one user
// can drive the whole QC/QA flow. Password re-auth is still enforced (e-signature dialog + backend).
export const isGmpRelaxed = (state) => !!state.auth.gmpControlsRelaxed

// Segregation of duties / 4-eyes: may the current user apply a signature here?
// - must hold `capability` (if one is required), and
// - must NOT be in `excludedMemberIds` (e.g. the analyst can't review their own work).
// Builds on the PerformerConstraint "DIFFERENT" concept. Returns { allowed, reasonKey },
// where reasonKey is an i18n key explaining a block (null when allowed).
export function canSign(state, { capability = null, excludedMemberIds = [] } = {}) {
  // SPEC-025: in local dev with controls relaxed, allow every signature (password still required).
  if (isGmpRelaxed(state)) {
    return { allowed: true, reasonKey: null }
  }
  const memberId = state.auth.memberId
  if (capability && !hasQcCapability(state, memberId, capability)) {
    return { allowed: false, reasonKey: "limsEsigBlockedCapability" }
  }
  if (excludedMemberIds && excludedMemberIds.includes(memberId)) {
    return { allowed: false, reasonKey: "limsEsigBlockedSelf" }
  }
  return { allowed: true, reasonKey: null }
}
